<template lang="html">
  <div class="cw-reset-password">
    <div class="card-image">
      <div class="hero is-small">
        <div class="hero-body has-text-centered">
          <div class="title is-3">Reset Account Password</div>
        </div>
      </div>
    </div>
    <div class="card-content">
      <section class="section">
        <div class="label font-light">Reset Password For</div>
        <p class="is-size-4 is-pad-bottom-1">{{ tokenPayload.email }}</p>

        <form class="form">
          <div class="field">
            <div class="label font-light">Password</div>
            <div class="control has-icons-left">
              <span class="icon is-left">
                <i class="las la-2x la-key"></i>
              </span>
              <input
                type="password"
                class="input is-underlined is-medium"
                :class="{ 'is-danger': passwordError !== null }"
                @input="$v.password.$touch()"
                @focus="$v.password.$touch()"
                placeholder="New Password"
                v-model="password"
              />
              <p class="help" v-if="passwordError">{{ passwordError }}</p>
            </div>
          </div>
          <div class="field">
            <div class="control has-icons-left">
              <span class="icon is-left">
                <i class="las la-2x la-key"></i>
              </span>
              <input
                type="password"
                class="input is-underlined is-medium"
                :class="{ 'is-danger': confirmPasswordError !== null }"
                @input="$v.confirmPassword.$touch()"
                @focus="$v.confirmPassword.$touch()"
                placeholder="Confirm Password"
                v-model="confirmPassword"
              />
              <p class="help" v-if="confirmPasswordError">
                {{ confirmPasswordError }}
              </p>
            </div>
          </div>
          <div class="field is-grouped is-grouped-right">
            <div class="control">
              <button
                class="button is-medium is-primary is-rounded"
                type="button"
                name="button"
                @click="submit"
              >
                Reset Password
              </button>
            </div>
          </div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import jwt from 'jsonwebtoken';
import axios from 'axios';
let apiHost = process.env.VUE_APP_API_HOST;

import { validationMixin } from 'vuelidate';
import { required, minLength, sameAs } from 'vuelidate/lib/validators';

export default {
  name: 'cw-reset-password',
  // share common functionality with component mixins
  mixins: [validationMixin],
  props: {},
  // variables
  data() {
    return {
      password: '',
      confirmPassword: '',
    };
  },
  validations: {
    password: {
      required,
      minLength: minLength(6),
    },
    confirmPassword: {
      required,
      sameAsPassword: sameAs('password'),
    },
  },
  computed: {
    tokenPayload() {
      let token = this.$route.query.token;
      let payload = jwt.decode(token);
      return payload;
    },
    passwordError() {
      let requiredErr = this.$v.password.$dirty && !this.$v.password.required;
      let lengthErr = this.$v.password.$dirty && !this.$v.password.minLength;

      if (requiredErr) {
        return 'A password is required.';
      } else if (lengthErr) {
        return 'Must be at least 6 characters.';
      } else {
        return null;
      }
    },
    confirmPasswordError() {
      let requiredErr =
        this.$v.confirmPassword.$dirty && !this.$v.confirmPassword.required;
      let matchErr =
        this.$v.confirmPassword.$dirty &&
        !this.$v.confirmPassword.sameAsPassword;

      if (requiredErr) {
        return 'Password confirmation is required.';
      } else if (matchErr) {
        return 'Passwords do not match.';
      } else {
        return null;
      }
    },
  },
  components: {},
  // methods
  watch: {},
  methods: {
    async submit() {
      // Validate Client side
      if (this.$v.$invalid) {
        this.$v.$touch();
        this.$modal.show('alert', {
          title: 'Insufficient Info',
          message:
            'Some of the fields are invalid. Please check that you have entered the required information.',
          type: 'warning',
        });
        return;
      }

      try {
        this.$modal.show('wifi-loader', { message: 'Processing...' });

        await axios.post(`${apiHost}/auth/password-reset`, {
          token: this.$route.query.token,
          password: this.password,
        });

        this.password = '';
        this.confirmPassword = '';
        this.$modal.hide('wifi-loader');

        this.$modal.show('alert', {
          title: 'Password Reset',
          message:
            'Your password has been reset. You will recieve a confirmation email soon.',
          type: 'success',
        });

        this.$router.push({ name: 'Login' });
      } catch (err) {
        this.$modal.hide('wifi-loader');
        let res = err.response;
        if (res && res.data) {
          this.$modal.show('alert', {
            title: res.data.title,
            message: res.data.message,
            type: 'warning',
          });
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped></style>
